import { DeliveryPeriodType } from '../models/config-strip-state.models';

import { mapBulkDeliveryPeriodToFuture } from './map-bulk-delivery-to-future';
import { isNowDateContainer } from './now-date-container/is-now-date-container';

// This function replaces "now date container" with the actual timestamp, that is created outside of the function
// so all basket items have same now date

// We carry "now date containers" until this function call to eliminate duplication of now date
// when timestamps are created at different points of time
export const requestedDeliveryDateToTimestamp = (
  requestedDeliveryDate: string,
  deliveryPeriodType: DeliveryPeriodType | undefined,
  nowStamp: string,
) => {
  if (isNowDateContainer(requestedDeliveryDate)) {
    return nowStamp;
  }
  return mapBulkDeliveryPeriodToFuture(
    requestedDeliveryDate,
    deliveryPeriodType,
  );
};
